import type { HomologationItemMessages } from '@/entities/Document';

export const DEFAULT_APPROVE_ERROR_MESSAGE = 'Erro ao salvar Aprovação. Tente novamente';
export const DOCUMENT_NOT_PENDING_APPROVAL_MESSAGE =
  'Esta revisão não está mais pendente de aprovação.';
export const RECORD_NOT_PENDING_APPROVAL_MESSAGE =
  'Este registro não está mais pendente de aprovação.';
export const APPROVAL_ITEM_LOAD_ERROR_MESSAGE = 'Não foi possível carregar o documento.';

export const APPROVAL_ITEM_MESSAGES: HomologationItemMessages = {
  documentNotPending: DOCUMENT_NOT_PENDING_APPROVAL_MESSAGE,
  recordNotPending: RECORD_NOT_PENDING_APPROVAL_MESSAGE,
  loadError: APPROVAL_ITEM_LOAD_ERROR_MESSAGE,
};
